import React from "react";

const ToggleSwitch = ({ checked = false, onChange, size = "medium", disabled = false }) => {
    const sizeClasses = {
        small: "h-6 w-10",
        medium: "h-8 w-14",
        large: "h-10 w-20",
    };

    const dotSizeClasses = {
        small: "h-4 w-4",
        medium: "h-6 w-6",
        large: "h-8 w-8",
    };

    const translateClasses = {
        small: "translate-x-4",
        medium: "translate-x-6",
        large: "translate-x-10",
    };

    return (
        <label className={`flex cursor-pointer select-none items-center ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}>
            <div className="relative">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => !disabled && onChange(!checked)}
                    className="sr-only"
                    disabled={disabled}
                />
                <div
                    className={`block rounded-full transition-colors duration-300 ${sizeClasses[size]} ${checked ? "bg-bgprimary" : "bg-[#E5E7EB]"
                        }`}
                ></div>
                <div
                    className={`dot absolute left-1 top-1 rounded-full bg-white shadow-md transition-transform duration-300 ${dotSizeClasses[size]} ${checked ? translateClasses[size] : ""
                        }`}
                ></div>
            </div>
        </label>
    );
};

export default ToggleSwitch;
